// extracted by mini-css-extract-plugin
export var inner = "fc-content-list-module--inner--1c6f7";
export var item = "fc-content-list-module--item--2ec35";
export var items = "fc-content-list-module--items--7a74c";
export var root = "fc-content-list-module--root--2e507";
export var text = "fc-content-list-module--text--bf589";
export var title = "fc-content-list-module--title--5a771";
export var white = "fc-content-list-module--white--a8548";